import { emptyMatchDayModel } from './../models/MatchDayModel';
import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { LeagueState, emptyNextMatchWidgetModel, emptyLastMatchWidgetModel } from './models';
import { RootState } from '@/store';

export const leagueModuleName = 'leagueModule';

export const state: LeagueState = {
  settings: undefined,
  leagueTable: {isLoaded: false, leagueTableItems: []},
  nextMatchWidget: { isFetched: false, nextMatch: emptyNextMatchWidgetModel },
  lastMatchWidget: { isFetched: false, lastMatch: emptyLastMatchWidgetModel },
  lastMatchDayResultsWidget: { isFetched: false, lastMatchDayResults: { matchDay: emptyMatchDayModel, results: [] } },
  loaded: false,
};

export const leagueModule: Module<LeagueState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
